export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    id="Delighted-Icon--Streamline-Svg-Logos"
    height="24"
    width="24"
  >
    <path
      fill="#4c4c4b"
      d="M12 0.25C5.5107 0.25 0.25 5.5107 0.25 12s5.2607 11.75 11.75 11.75 11.75 -5.2607 11.75 -11.75S18.4893 0.25 12 0.25ZM7.801575 17.6355c2.673775 2.16715 6.859425 1.5611 9.270375 -1.32435 -2.3387 -0.31 -5.100125 -1.04255 -7.34025 -1.916075 -0.605775 1.1694 -1.070725 2.0992 -1.930125 3.240425Zm6.875325 -11.815725c-1.465275 0.375625 -3.38135 3.64425 -4.508425 7.22275 2.73315 1.239825 4.874675 1.747 7.8333 2.1039 0 0 2.73325 -6.1145 -3.324875 -9.32665ZM13.690625 20.84775c-3.1927 0.61395 -7.326125 -1.056675 -8.8618 -3.5081 0 0 2.19715 -2.4362 2.803675 -3.86035 -0.653975 -0.50735 -1.047325 -0.799275 -1.46455 -1.171325 -2.407625 -2.14675 -2.36485 -5.101325 0.091725 -7.19935 2.738925 -2.339175 6.907975 -2.7174625 10.124625 -0.918525 3.24805 1.816475 5.1008 5.5539 4.512475 9.10285 -0.64505 3.890725 -3.564375 6.854475 -7.20615 7.5548Zm-1.127075 -15.4976c-1.841175 -0.026625 -3.232825 0.34285 -4.52615 1.25705 -2.125925 1.502725 -2.02255 3.9001 0.2552 5.330375 1.086875 -2.501725 1.966575 -4.7773 4.27095 -6.587425Z"
      stroke-width="0.25"
    ></path>
  </svg>
);
